(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ordo-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__ordoUrg) return;
  window.__ordoUrg = 1;
  var d = document;
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function lang(){ return d.documentElement.lang || 'fr-FR'; }

  /* Compte a rebours sur une vraie date de fin de remise. */
  function tick(){
    var els = d.querySelectorAll('[data-o-count]');
    if(!els.length) return;
    els.forEach(function(el){
      var end = new Date(el.getAttribute('data-o-count')).getTime();
      var host = el.closest('[data-o-urg]');
      if(isNaN(end)){ if(host) host.hidden = true; return; }
      var diff = end - Date.now();
      if(diff <= 0){ if(host) host.hidden = true; return; }
      if(host) host.hidden = false;
      var j = Math.floor(diff / 86400000);
      var h = Math.floor(diff % 86400000 / 3600000);
      var m = Math.floor(diff % 3600000 / 60000);
      var s = Math.floor(diff % 60000 / 1000);
      el.textContent = j > 0
        ? j + ' j ' + pad(h) + ' h ' + pad(m) + ' min'
        : pad(h) + ' h ' + pad(m) + ' min ' + pad(s) + ' s';
    });
  }

  /* Date de livraison estimee, en jours ouvres, calculee chez le visiteur. */
  function ouvre(n){
    var x = new Date(), i = 0;
    while(i < n){
      x.setDate(x.getDate() + 1);
      var w = x.getDay();
      if(w !== 0 && w !== 6) i++;
    }
    return x;
  }
  function livraison(){
    var els = d.querySelectorAll('[data-o-liv]:not([data-o-done])');
    if(!els.length) return;
    var f;
    try{ f = new Intl.DateTimeFormat(lang(), { day:'numeric', month:'long' }); }catch(e){ return; }
    els.forEach(function(el){
      var a = parseInt(el.getAttribute('data-o-min'), 10) || 7;
      var b = parseInt(el.getAttribute('data-o-max'), 10) || 15;
      var t = el.getAttribute('data-o-liv') || '';
      if(t.indexOf('[du]') === -1 && t.indexOf('[au]') === -1) return;
      el.setAttribute('data-o-done','1');
      el.textContent = t.replace('[du]', f.format(ouvre(a))).replace('[au]', f.format(ouvre(b)));
    });
  }

  function init(){ tick(); livraison(); }
  if(d.readyState === 'loading'){ d.addEventListener('DOMContentLoaded', init); } else { init(); }
  d.addEventListener('shopify:section:load', init);
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
